export default __webpack_public_path__ + "static/proceduresBgImage-ed0dbb11b7c4abcffef57d7fa60b5c24.png";